import React from 'react'

const StatusText = ({ className, icon, text }) => (
    <span className={className}>
        <i className={icon} aria-hidden="true" />
        <span>{text}</span>
    </span>
)

export const SaveStatus = ({ syncing, progress, saveState }) => {
    let content = null

    if (syncing) {
        content = <StatusText className="rt-save-status-muted" icon="fas fa-sync-alt fa-spin" text={__('Syncing with the reviews provider...')} />
    } else if (progress) {
        content = <StatusText className="rt-save-status-muted" icon="fas fa-circle-notch fa-spin" text={__('Updating :current of :total...', { ':current': progress.current, ':total': progress.total })} />
    } else if (saveState === 'saving') {
        content = <StatusText className="rt-save-status-muted" icon="fas fa-circle-notch fa-spin" text={__('Saving...')} />
    } else if (saveState === 'saved') {
        content = <StatusText className="rt-save-status-saved" icon="fas fa-check" text={__('Saved')} />
    } else if (saveState === 'error') {
        content = <StatusText className="rt-save-status-error" icon="fas fa-exclamation-circle" text={__('Some changes could not be saved')} />
    }

    return (
        <div className="rt-save-status" role="status" aria-live="polite">
            {content}
        </div>
    )
}
